module.exports = __webpack_public_path__ + "static/media/style-guide.2300e665.svg";